import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { HELP_ACCOUNTS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import Account from "./Account";
import AccountList from "./AccountList";

export default function Accounts() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_ACCOUNTS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate("/backstage/accounts/new"));

  return <MasterDetail identifier="id" master={<AccountList />} detail={<Account />} />;
}
